"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _informationStepModule = _interopRequireDefault(require("./information-step.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var createProjectsDropdownOptions = function createProjectsDropdownOptions(projects) {
  return projects.sort(function (a, b) {
    return a.projectName > b.projectName ? 1 : -1;
  }).map(function (project) {
    return {
      label: project.projectName,
      value: project.id
    };
  });
};

var createAssetNameDropdownOptions = function createAssetNameDropdownOptions(assets) {
  return assets.filter(function (asset) {
    return asset.hasWritingAccess === true;
  }).sort(function (a, b) {
    return a.name > b.name ? 1 : -1;
  }).reduce(function (result, asset) {
    var newResult = result;
    newResult[asset.id] = asset.name;
    return newResult;
  }, {});
};

var getSharePortalsDropdownOptions = function getSharePortalsDropdownOptions(portalsObject) {
  return Object.keys(portalsObject).reduce(function (result, portalId) {
    // eslint-disable-next-line no-param-reassign
    result[portalId] = portalsObject[portalId].name;
    return result;
  }, {});
};

var Information = function Information(_ref) {
  var _tour$sharedWithPorta, _ref6;

  var hasPermissions = _ref.hasPermissions,
      tour = _ref.tour,
      assets = _ref.assets,
      linkedPortals = _ref.linkedPortals,
      projects = _ref.projects,
      errors = _ref.errors,
      touched = _ref.touched,
      onUpdate = _ref.onUpdate,
      isShareTour = _ref.isShareTour;
  var name = tour.name,
      externalId = tour.externalId,
      dataRequest = tour.dataRequest,
      _tour$projects = tour.projects,
      tourProjects = _tour$projects === void 0 ? [] : _tour$projects;

  var _ref2 = dataRequest || {},
      dataRequestType = _ref2.type,
      haulerPortalId = _ref2.haulerPortalId,
      haulerEmail = _ref2.haulerEmail;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showHaulerMailError = _useState2[0],
      setShowHaulerMailError = _useState2[1];

  var projectsDropdownOptions = (0, _react.useMemo)(function () {
    return createProjectsDropdownOptions(projects);
  }, [projects]);
  var assetNamesDropdownOptions = (0, _react.useMemo)(function () {
    return createAssetNameDropdownOptions(assets);
  }, [assets]);
  var sharePortalsDropdownOptions = (0, _react.useMemo)(function () {
    return getSharePortalsDropdownOptions(linkedPortals);
  }, [linkedPortals]); // only display the toggle and data sharing options when there are linked portals available

  var canShareToPortal = Object.keys(sharePortalsDropdownOptions).length > 0;

  var onAssetTypeChanged = function onAssetTypeChanged(newAssetType) {
    // all properties have to be unset
    switch (newAssetType) {
      case 'APP':
        onUpdate({
          dataRequest: {
            type: 'APP',
            haulerPortalId: null,
            haulerEmail: null
          },
          assetId: null,
          assetType: null
        });
        break;

      case 'PORTAL':
        onUpdate({
          dataRequest: {
            type: 'PORTAL',
            haulerPortalId: null,
            haulerEmail: null
          },
          assetId: null,
          assetType: null
        });
        break;

      case 'ASSET':
        onUpdate({
          dataRequest: null
        });
        break;

      default:
    }
  };

  var onProjectChange = function onProjectChange(id, index) {
    if (!tourProjects.some(function (tourProject) {
      return tourProject.id === id;
    })) {
      var _projects$find;

      var _ref3 = (_projects$find = projects.find(function (currentProject) {
        return currentProject.id === id;
      })) !== null && _projects$find !== void 0 ? _projects$find : {},
          tourProperties = _ref3.tourProperties,
          projectType = _ref3.projectType;

      var newProject = _objectSpread(_objectSpread({}, tourProjects[index]), {
        id: id,
        type: projectType,
        tourProperties: Object.fromEntries(Object.entries(tourProperties !== null && tourProperties !== void 0 ? tourProperties : {}).map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 1),
              key = _ref5[0];

          return [key, ''];
        }))
      });

      onUpdate({
        projects: [].concat(_toConsumableArray(tourProjects.slice(0, index)), [newProject], _toConsumableArray(tourProjects.slice(index + 1)))
      });
    }
  };

  var onInputChange = function onInputChange(index, key, value) {
    var project = _objectSpread(_objectSpread({}, tourProjects[index]), {}, {
      tourProperties: _objectSpread(_objectSpread({}, tourProjects[index].tourProjects), {}, _defineProperty({}, key, value))
    });

    var updatedProjects = tourProjects.slice(0);
    updatedProjects.splice(index, 1, project);
    onUpdate({
      projects: updatedProjects
    });
  };

  var onAddClicked = function onAddClicked() {
    onUpdate({
      projects: [].concat(_toConsumableArray(tourProjects), [{
        id: null,
        type: null,
        tourProperties: {}
      }])
    });
  };

  var onRemoveClicked = function onRemoveClicked(index) {
    var updatedProjects = tourProjects.slice(0);
    updatedProjects.splice(index, 1);
    onUpdate({
      projects: updatedProjects
    });
  };

  var sharedWithPortals = (_tour$sharedWithPorta = tour.sharedWithPortals) !== null && _tour$sharedWithPorta !== void 0 ? _tour$sharedWithPorta : [];
  var sharedWithPortalId = (_ref6 = sharedWithPortals[0] && sharedWithPortals[0].id) !== null && _ref6 !== void 0 ? _ref6 : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-96 px-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-12 w-96"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: name,
    onChange: function onChange(newValue) {
      return onUpdate({
        name: newValue
      });
    },
    type: "text",
    error: touched.name && errors.name ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.road.createTour.name.error"
    }) : null,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.road.createTour.name"
    }, function (message) {
      return "".concat(message, "*");
    }),
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: externalId,
    onChange: function onChange(newValue) {
      return onUpdate({
        externalId: newValue
      });
    },
    type: "text",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.road.createTour.externalId"
    }),
    maxLength: 64
  }), canShareToPortal || hasPermissions(['module.tour.haulerEmail']) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioGroup, {
    name: "handlingAsset",
    className: "radio-buttons",
    value: dataRequestType || 'ASSET',
    onChange: function onChange(value) {
      return onAssetTypeChanged(value);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioButton, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.ownEquipment"
    }),
    value: "ASSET"
  }), canShareToPortal ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioButton, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.requestFromHaulerPortal"
    }),
    value: "PORTAL"
  }) : null, hasPermissions(['module.tour.haulerEmail']) ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioButton, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.requestFromTourDriverApp"
    }),
    value: "APP"
  }) : null)) : null, !dataRequestType ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, {
      className: "fill-primary inline-block"
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.asset"
    }),
    source: assetNamesDropdownOptions,
    value: tour.assetId,
    valueType: "Integer",
    onChange: function onChange(assetId) {
      var assetObject = assets.find(function (asset) {
        return asset.id === assetId;
      });

      if (assetObject) {
        onUpdate({
          assetId: assetObject.id
        });
        onUpdate({
          assetType: assetObject.type
        });
      }
    }
  }) : null, dataRequestType === 'PORTAL' ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.requestDataFrom"
    }),
    source: sharePortalsDropdownOptions,
    value: haulerPortalId,
    valueType: "Integer",
    onChange: function onChange(newValue) {
      return onUpdate({
        dataRequest: _objectSpread(_objectSpread({}, dataRequest), {}, {
          haulerPortalId: newValue
        })
      });
    }
  }) : null, dataRequestType === 'APP' && hasPermissions(['module.tour.haulerEmail']) ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.requestFromHaulerEmail"
    }),
    type: "text",
    value: haulerEmail,
    onChange: function onChange(newValue) {
      setShowHaulerMailError(false);
      onUpdate({
        dataRequest: _objectSpread(_objectSpread({}, dataRequest), {}, {
          haulerEmail: newValue
        })
      });
    },
    error: showHaulerMailError ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.emailIsNotValid"
    }) : null,
    onBlur: function onBlur() {
      var _errors$dataRequest;

      if ((_errors$dataRequest = errors.dataRequest) !== null && _errors$dataRequest !== void 0 && _errors$dataRequest.haulerEmail) {
        setShowHaulerMailError(true);
      } else {
        setShowHaulerMailError(false);
      }
    }
  }) : null, projects.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, tourProjects.map(function (project, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: _informationStepModule["default"].container
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Dropdown, {
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.project"
      }),
      onChange: function onChange(id) {
        return onProjectChange(id, index);
      },
      source: projectsDropdownOptions,
      value: Number(project.id),
      className: "w-96"
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: _informationStepModule["default"].removeProject,
      onClick: function onClick() {
        return onRemoveClicked(index);
      }
    })), project.tourProperties ? Object.entries(project.tourProperties).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-indent
        _react["default"].createElement(_nicbaseForms.Input, {
          value: value,
          label: key,
          onChange: function onChange(inputValue) {
            return onInputChange(index, key, inputValue);
          }
        })
      );
    }) : null);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "add-text-primary inline-flex items-center cursor-pointer font-bold pb-8",
    onClick: onAddClicked
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "inline-block fill-primary mr-2 cursor-pointer"
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.addProject"
  })))), isShareTour && canShareToPortal && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.sharedDataWith"
  }, function (text) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-primary"
    }, text);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.portal"
    }),
    source: sharePortalsDropdownOptions,
    value: sharedWithPortalId,
    valueType: "Integer",
    onChange: function onChange(updatedPortalId) {
      return onUpdate({
        sharedWithPortals: updatedPortalId !== null ? [{
          id: updatedPortalId,
          write: false
        }] : []
      });
    }
  }))));
};

Information.propTypes = {
  hasPermissions: _propTypes["default"].func.isRequired,
  tour: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    assetId: _propTypes["default"].number,
    externalId: _propTypes["default"].string,
    dataRequest: _propTypes["default"].shape({}),
    projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    sharedWithPortals: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }),
  assets: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  linkedPortals: _propTypes["default"].shape({}),
  projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    projectName: _propTypes["default"].string,
    endpointId: _propTypes["default"].number,
    sharedData: _propTypes["default"].arrayOf(_propTypes["default"].string)
  })),
  errors: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    dataRequest: _propTypes["default"].shape({
      haulerEmail: _propTypes["default"].string
    })
  }),
  touched: _propTypes["default"].shape(),
  onUpdate: _propTypes["default"].func,
  isShareTour: _propTypes["default"].bool
};

var noop = function noop() {};

Information.defaultProps = {
  tour: {},
  assets: [],
  linkedPortals: {},
  projects: [],
  errors: {},
  touched: {},
  onUpdate: noop,
  isShareTour: false
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.road'])(Information);

exports["default"] = _default;